import { useMenuItems } from "core/hooks/useMenuItems";
import { ApplicationErrorBoundaryPage } from "core/pages/ApplicationErrorBoundaryPage";
import type { ReactNode } from "react";
import { ApplicationLoadingDisplay } from "../ApplicationLoadingDisplay";
import { ErrorComponent } from "../ErrorComponent";
import { useFeatureFlagsRequest } from "../useFeatureFlags";

export function GlobalLoader({ children }: { children: ReactNode }) {
  const { isLoading: isMenuItemsLoading, isError: isMenuItemError } =
    useMenuItems();
  const { isLoading: areFeatureFlagsLoading, isError: featureFlagsError } =
    useFeatureFlagsRequest();

  if (isMenuItemError || featureFlagsError) {
    return (
      <ApplicationErrorBoundaryPage>
        <ErrorComponent apiError={isMenuItemError || featureFlagsError} />
      </ApplicationErrorBoundaryPage>
    );
  }
  if (isMenuItemsLoading || areFeatureFlagsLoading) {
    return <ApplicationLoadingDisplay />;
  }

  return <>{children}</>;
}
